export default class AsyncTools {
  private sleepInterval: NodeJS.Timeout | null = null

  /**
   * Sleep for a given number of milliseconds, asynchronously
   * @param ms - The number of milliseconds to sleep
   * @returns {Promise<number>} A promise that resolves with the number of milliseconds slept
   */
  sleep(ms: number): Promise<number> {
    return new Promise<number>((resolve) => {
      this.sleepInterval = setTimeout(() => {
        if (this.sleepInterval) {
          clearTimeout(this.sleepInterval)
        }
        resolve(ms)
      }, ms)
    })
  }
}
